'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ReactKonsulIDOperations = require('./ReactKonsulIDOperations');

var _ReactKonsulIDOperations2 = _interopRequireDefault(_ReactKonsulIDOperations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactKonsulTextComponent = function ReactKonsulTextComponent(text) {
  this._currentElement = text;
  this._stringText = '' + text;
  this._parent = null;
  this._domID = null;
  this._node = null;
};

var ReactKonsulComponentMixin = {
  mountComponent: function mountComponent(transaction, nativeParent, containerInfo, context) {
    this._parent = nativeParent;
    this._node = this.mountNode(nativeParent);
    this._domID = containerInfo._idCounter++;
    this._node.setOrder(this._domID);

    return this.node;
  },
  mountNode: function mountNode(parent) {
    var konsul = _ReactKonsulIDOperations2.default.konsul;
    var element = konsul.text();
    element.setChildren([this._stringText]);
    element.parent = parent._node;

    parent._node.append(element);

    return element;
  },
  receiveComponent: function receiveComponent(nextText, transaction, context) {
    var konsul = _ReactKonsulIDOperations2.default.konsul;

    this._stringText = nextText;
    this._node.setChildren([nextText]);
    konsul.debounceRender();
  },
  getHostNode: function getHostNode() {
    return this._node;
  },
  unmountComponent: function unmountComponent() {
    this._node.destroy();
  }
};

Object.assign(ReactKonsulTextComponent.prototype, ReactKonsulComponentMixin);

exports.default = ReactKonsulTextComponent;


//////////////////
// WEBPACK FOOTER
// ../lib-react/lib/ReactKonsulTextComponent.js
// module id = 679
// module chunks = 0